import InvoiceGlobalStatusBadge, {
  optionsForInvoiceGlobalStatus,
} from './InvoiceGlobalStatusBadge';
export { optionsForInvoiceGlobalStatus };
export default InvoiceGlobalStatusBadge;
